import type React from 'react';
import styles from './section-label.module.scss';

export interface SectionLabelProps {
  children: React.ReactNode;
  as?: 'h2' | 'h3' | 'div';
  align?: 'start' | 'center';
  className?: string;
}

export const SectionLabel: React.FC<SectionLabelProps> = ({ children, as: Tag = 'h2', align = 'start', className }) => {
  const cls = [styles.sectionLabel, align === 'center' ? styles.center : null, className].filter(Boolean).join(' ');
  return <Tag className={cls}>{children}</Tag>;
};
